import { render, staticRenderFns } from "./loginH5.vue?vue&type=template&id=30267c6a&scoped=true&"
import script from "./loginH5.vue?vue&type=script&lang=ts&"
export * from "./loginH5.vue?vue&type=script&lang=ts&"
import style0 from "./loginH5.vue?vue&type=style&index=0&id=30267c6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30267c6a",
  null
  
)

export default component.exports